export enum ReassignUserAction {
    FILL_REASSIGN_USER,
    FILL_TRACKING_USER,
    CHANGE_REASSIGN_USER_ID,
    UPDATE_ITEM,
    LOADING,
    SELECT_USER,
    SELECT_ALL_USER,
    CHECK_CAN_BOSS_FOLLOW_UP
}

export enum ItemNameEnum {
    AREA = 'area',
    ROLE = 'role',
    STORE = 'store',
    DIVISION = 'division',
    USERTYPE = 'userType',
    DEPARTMENT = 'department'
}

export enum LoadingNameEnum {
    REASSIGN_TABLE = 'reassignTable',
    TRACKING_TABLE = 'trackingTable',
    TRACKING_SAVE = 'trackingSave',
    REASSIGN_SAVE = 'reassignSave',
}